// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--PmSs2","BodyContainerText":"_BodyContainerText--DqC4f","WarningIcon":"_WarningIcon--HX1jT"};